<template>
  <div class="saving-bar" :class="isSaving? 'saving-bar-show' : 'saving-bar-hidden'" :style="{bottom: anchor + 'px'}">
    <v-alert class="ma-0 pa-2"  max-height="50" text>
      <div class="first-letter-capital px-3">
        {{isSavingText}}
      </div>
      <template v-slot:prepend>
        <span class="px-3">
          <img width="30" height="30" src="/img/loader.gif" />
        </span>
      </template>
    </v-alert>
  </div>
</template>

<script lang='ts'>
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component

export default class IsSavingComp extends Vue {
  @Prop({ required: true })
  public isSaving: boolean | undefined;

  @Prop({ required: true })
  public anchor: any;

  get isSavingText() {
    return this.$t('isSavingText').toString();
  }

}
</script>

<style lang='stylus'>
.saving-bar {
  position absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #FFF
}
.saving-bar-hidden {
  max-height: 0;
  transition: max-height 0.65s ease-out;
  overflow: hidden;
}
.saving-bar-show {
  max-height: 50px;
  transition: max-height 0.65s ease-out;
}
</style>
